module.exports = __webpack_public_path__ + "img/steps-api.4feb32c0.png";